import Tooltip from "@mui/material/Tooltip";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { AccountCircle } from "@material-ui/icons";

const ParticipantsTooltip = ({ leader, others = [], showIcon = true }) => {
  if (!leader) return null;

  const othersCount = others.length;

  const tooltipContent = (
    <Box sx={{ p: 0.5 }}>
      {others.map((user, index) => (
        <Typography
          key={index}
          variant="body2"
          sx={{ px: 1, py: 0.5, whiteSpace: "nowrap" }}
        >
          {user.firstName} {user.lastName}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Tooltip
      title={othersCount > 0 ? tooltipContent : ""}
      placement="bottom-start"
      arrow
      disableHoverListener={othersCount === 0}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "text.secondary",
          cursor: othersCount > 0 ? "pointer" : "default",
        }}
      >
        {showIcon && <AccountCircle style={{ fontSize: "0.8rem" }} />}

        <Typography variant="body2">
          {leader.firstName} {leader.lastName}
        </Typography>

        {othersCount > 0 && (
          <Typography variant="body2">+{othersCount}</Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default ParticipantsTooltip;
